import { render, staticRenderFns } from "./FieldM2.vue?vue&type=template&id=0d771328"
import script from "./FieldM2.vue?vue&type=script&lang=js"
export * from "./FieldM2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports